"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnvironmentVariables = (function () {
    function EnvironmentVariables() {
    }
    EnvironmentVariables.lookupString = function (key, defaultValue) { var _a, _b, _c, _d; return (_d = (_b = (_a = window === null || window === void 0 ? void 0 : window._env_) === null || _a === void 0 ? void 0 : _a[key]) !== null && _b !== void 0 ? _b : (_c = process === null || process === void 0 ? void 0 : process.env) === null || _c === void 0 ? void 0 : _c[key]) !== null && _d !== void 0 ? _d : defaultValue; };
    EnvironmentVariables.lookupNumber = function (key, radix, defaultValue) {
        if (radix === void 0) { radix = 10; }
        var val = EnvironmentVariables.lookupString(key);
        if (!!val) {
            return parseInt(val, radix);
        }
        return defaultValue;
    };
    EnvironmentVariables.lookupFloat = function (key, defaultValue) {
        var val = EnvironmentVariables.lookupString(key);
        if (!!val) {
            return parseFloat(val);
        }
        return defaultValue;
    };
    EnvironmentVariables.lookupBoolean = function (key, defaultValue) {
        var val = EnvironmentVariables.lookupString(key);
        return (!!val && val.toLowerCase() === 'true') || !!defaultValue;
    };
    EnvironmentVariables.lookupJson = function (key, defaultValue) {
        var val = EnvironmentVariables.lookupString(key);
        if (!!val) {
            try {
                return JSON.parse(val);
            }
            catch (e) {
                console.error(e);
            }
        }
        return defaultValue;
    };
    return EnvironmentVariables;
}());
exports.default = EnvironmentVariables;
//# sourceMappingURL=environment-variables.js.map